import React from 'react';
import PropTypes from 'prop-types';
import { pagePropType } from 'app/common/selectors/page';
import OrderPageFormLite from './order-page-form-lite';
import AnnouncementBanner from './anouncement-banner';

import './order-page.less';

const OrderPage = props => (
  <div className='OrderPage contentPage'>
    {props.expressShippingEnabled ? (<AnnouncementBanner {...props} />) : null}
    <h1 className='h1'>{props.pageInfo.title}</h1>
    <div className='content'>
      <OrderPageFormLite {...props} />
    </div>
  </div>);

OrderPage.propTypes = {
  pageInfo: PropTypes.shape(pagePropType),
  expressShippingEnabled: PropTypes.bool,
  features: PropTypes.shape({
    SELL_GLOWFORGES_IN_SHOPIFY: PropTypes.bool,
  }).isRequired,
};

OrderPage.defaultProps = {
  pageInfo: {},
  expressShippingEnabled: false,
};

export default OrderPage;



// WEBPACK FOOTER //
// ./app/store/components/glowforge/order-page.jsx